export default __webpack_public_path__ + "static/media/PPSC-Logo.39248dad.png";